'use client';

import { Subsidiary } from '@coolblue-development/constants';
import { Link } from '@coolblue-development/freddy';
import selectChooseAlternativeTrigger from '@coolblue-development/ga4-events/triggers/Configurator/selectChooseAlternativeTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { useTranslation } from '@i18n/useTranslation';

import { useConfigurator } from '../ConfiguratorContext';

export default function AlternativeOverlayEntrance({ slotIndex }: { slotIndex: number }) {
  const { trackEvent } = useAnalytics();
  const { subsidiary } = useRequestContext();
  const { t } = useTranslation('webshop.productPage.configurator');
  const {
    configurator,
    actions: { setSelectedProductSlot, getProductByUseCaseAndSlot },
    states: { selectedUseCaseIndex }
  } = useConfigurator();

  const slot = configurator.useCases[selectedUseCaseIndex].slots[slotIndex];

  const product = getProductByUseCaseAndSlot({
    useCaseIndex: selectedUseCaseIndex,
    slotIndex
  });

  const trackingParams = {
    index: slotIndex,
    total_indices: configurator.useCases[selectedUseCaseIndex].slots.length,
    item_list_id: product?.id || 0,
    item_list_name: product?.productType?.singularName || '',
    number_of_items: slot.products.length
  };

  return (
    <Link
      onClick={event => {
        event.preventDefault();
        setSelectedProductSlot(slotIndex);
        trackEvent(selectChooseAlternativeTrigger(trackingParams));
      }}
    >
      {subsidiary === Subsidiary.DE ? t('chooseAlternative') : t('otherOptions')}
    </Link>
  );
}
